// Entrada do web: providers (TanStack Query, toast), roteador e service worker.
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { configurarCliente } from "./api/cliente";
import { criarQueryClient } from "./api/consultas";
import { CHAVE_SESSAO } from "./api/sessao";
import { registrarServiceWorker } from "@plataforma/pwa";
import { AvisoAtualizacao, ProvedorToast, Reconectando } from "./compartilhado/ui";
import "./index.css";
import { criarRoteador } from "./rotas";

const queryClient = criarQueryClient();
const roteador = criarRoteador();

// Sessão perdida (401) ou senha temporária (403): limpa o cache e leva ao lugar certo sem recarregar.
configurarCliente({
  aoPerderSessao(destino) {
    queryClient.clear();
    queryClient.setQueryData(CHAVE_SESSAO, null);
    void roteador.navigate(destino, { replace: true });
  },
  aoExigirTrocaDeSenha() {
    void queryClient.invalidateQueries({ queryKey: CHAVE_SESSAO });
    void roteador.navigate("/painel/trocar-senha", { replace: true });
  },
  // Escrita recusada com os termos pendentes: a sessão volta com `termosPendentes` e a folha bloqueante abre.
  aoExigirNovoAceite() {
    void queryClient.invalidateQueries({ queryKey: CHAVE_SESSAO });
  },
  // Nunca aceitou os termos: a sessão recarregada leva o guarda (ExigirAluno) ao onboarding; navega já.
  aoExigirOnboarding() {
    void queryClient.invalidateQueries({ queryKey: CHAVE_SESSAO });
    void roteador.navigate("/boas-vindas/1", { replace: true });
  },
});

document.documentElement.dataset.versaoWeb = __VERSAO_WEB__;
registrarServiceWorker();

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProvedorToast>
        <RouterProvider router={roteador} />
        <Reconectando />
        <AvisoAtualizacao />
      </ProvedorToast>
    </QueryClientProvider>
  </StrictMode>,
);
